<template>
  <section class="app-main" v-bind:class="{'content-full': $route.path==='/' || $route.path==='/terms' || $route.path==='/forgotPassword' ||  $route.path==='/requestDemo' || $route.path.indexOf('/resetPassword') !== -1 || $route.path==='/login' || $route.path==='/onBoard' || $route.path.indexOf('/onBoardMember') !== -1}">
    <div class="container is-fluid is-marginless app-content" v-bind:class="{'landing-full': $route.path==='/'}">
      <levelbar></levelbar>
      <transition @after-enter="afterEnter"
        mode="out-in"
        enter-active-class="fadeIn"
        leave-active-class="fadeOut"
        appear>
        <router-view class="animated"></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
import Levelbar from './Levelbar'

export default {
  computed: {
  },
  methods: {
    afterEnter () {
      this.$root.$emit('scrollAfterEnter')
    }
  },
  components: {
    Levelbar
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/variables';
@import '~bulma/sass/utilities/mixins';

.app-main {
  min-height: calc(100vh - 100px);
  padding-top: 70px;
  margin-left: 0px;
  transform: translate3d(0, 0, 0);
  transition: transform .3s ease-in-out,margin .3s ease-in-out;  

  @media screen and (max-width: 1023px) {
    margin-left: 0px;
  }
}

.content-full{
  margin-left: 0px!important;
}

.app-main .app-content.landing-full {
  padding: 0px;
} 

/*.tile.is-child.box {
  min-height: 400px;
}*/

.app-main .app-content {
  padding: 5px;
  // min-height: 500px;
}

.customBox {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
}
</style>



// WEBPACK FOOTER //
// AppMain.vue?9a528a46